<template>
  <ViewCustomData entityName="report" entitySpec="data" serviceName="BaseService" :columns="REPORT_COLUMNS"
    :dictionary="REPORT_FILTERS" @selectedRow="onSelectedRow" :dialog="reportDialog" :paginator="false" />
</template>

<script setup>
import { ref, shallowRef } from 'vue';
import ReportDialog from './ReportDialog';
import { REPORT_FILTERS, REPORT_COLUMNS } from './reportConstants';

const selected = ref(null);
const reportDialog = shallowRef(ReportDialog);

const onSelectedRow = (value) => {
  selected.value = value;
}
</script>